module.exports = __webpack_public_path__ + "static/letterpress_small-f40d0e27f07daae66a53d4689ad9de35.jpg";